"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const Button_1 = require("./Button");
const balloon_scss_1 = __importDefault(require("./styles/balloon.scss"));
function Balloon({ children, className, delay, icon }) {
    const ref = React.useRef(null);
    const [hidden, setHidden] = React.useState(delay ? true : false);
    const [clicked, setClicked] = React.useState(false);
    React.useEffect(() => {
        if (delay) {
            window.setTimeout(() => {
                setHidden(false);
            }, delay);
        }
        const parent = ref.current && ref.current.parentElement;
        const handler = () => requestAnimationFrame(() => {
            // Because React event is very slow
            setClicked(true);
        });
        if (parent) {
            parent.addEventListener('click', handler, {
                passive: true,
                once: true,
                capture: false
            });
        }
        return () => {
            if (parent) {
                parent.removeEventListener('click', handler);
            }
        };
    }, []);
    if (clicked)
        return null;
    return (React.createElement("div", { ref: ref, className: classnames_1.default(className, balloon_scss_1.default.root, hidden && balloon_scss_1.default.hidden), onClick: () => setClicked(true) },
        icon ? React.createElement(Button_1.Icon, { name: icon }) : null,
        children ? React.createElement("div", null, children) : null));
}
exports.Balloon = Balloon;
